export default function ContributionLabel() {
  return (
    <span data-testid="contribution-label">
      LUXEWELL <span className="italic normal-case tracking-[0.12em]">Gives</span>
    </span>
  );
}
